export default {"src":"/_next/static/media/Discord.a5da5625.svg","height":96,"width":127};